export default __webpack_public_path__ + "static/media/bg-vid.8238464b.webm";